import React from "react";
import annotationPlugin from "chartjs-plugin-annotation";
import {
	Chart as ChartJS,
	LinearScale,
	PointElement,
	LineElement,
	Legend,
	Tooltip,
	scales,
	CategoryScale,
} from "chart.js";
import { Bubble } from "react-chartjs-2";
import { numberFormatter } from "../../utils";

ChartJS.register(
	annotationPlugin,
	LinearScale,
	PointElement,
	LineElement,
	Tooltip,
	Legend,
	scales,
	CategoryScale
);

const BubbleChart = (props: { Graphdata: any; gmValue: any }) => {
	const { Graphdata, gmValue } = props;

	let plottedData: any = [];
	let labels: any = [];
	let pointRadius: any = [];
	let pointHoverRadius: any = [];
	let backgroundColor: any = [];

	const mapBetween = (
		currentNum: any,
		minAllowed: any,
		maxAllowed: any,
		min: any,
		max: any
	) => {
		return (
			((maxAllowed - minAllowed) * (currentNum - min)) / (max - min) +
			minAllowed
		);
	};

	const getColor = (val: any) => {
		let colorCode = "";

		if (val < 0.14) {
			colorCode = "#c79c38";
		} else if (val > 0.14 && val < gmValue) {
			colorCode = "#d55454";
		} else if (val > gmValue && val < gmValue + 0.05) {
			colorCode = "#60b5bf";
		} else if (val > gmValue + 0.05) {
			colorCode = "rgb(134, 188, 37)";
		} else {
			colorCode = "rgba(151, 151,152, 0.2)";
		}

		return colorCode;
	};

	Graphdata?.map((d: any) => {
		plottedData?.push({
			x: d.totalLineItems,
			y: d.spaPercent,
			// , r: d.sales_2023
		});
		labels?.push(d.MATERIAL_MATERIAL);

		if (d.spend < 1000000) {
			pointRadius.push(mapBetween(d.spend, 2, 18, 0, 2000000));
			pointHoverRadius.push(mapBetween(d.spend, 4, 20, 0, 1000000) + 2);
		} else {
			pointRadius.push(mapBetween(d.spend, 18, 25, 2000000, 100000000));
			pointHoverRadius.push(
				mapBetween(d.spend, 20, 27, 1000000, 100000000) + 2
			);
		}
		backgroundColor.push(getColor(d?.grossMargin));
	});

	const removeLeadingZero = (n: any) => {
		let newStr = n.replace(/^0+/, "");
		return newStr;
	};

	const options: any = {
		plugins: {
			legend: {
				display: false,
				labels: {
					fontColor: "blue",
					fontSize: 18,
				},
			},
			tooltip: {
				callbacks: {
					title: (context: any) => {
						let element = Graphdata[context[0].dataIndex];
						return (
							"Material: " +
							removeLeadingZero(element.MATERIAL_MATERIAL)
						);
					},
					label: function (context: any) {
						let element = Graphdata[context.dataIndex];

						return [
							"Total transaction: " + element.totalLineItems,
							"Spa percentage: " +
								numberFormatter(element.spaPercent, 0) +
								"%,",
							"Sales: " + numberFormatter(element.sales_2023, 2),
							"Supplier name: " + element.master_vendor_name,
						];
					},

					labelTextColor: function (context: any) {
						return "#d3d3d3";
					},
				},
				displayColors: false,
				backgroundColor: "#333333",
			},
			scales: {
				x: {
					offset: true,
					border: {
						color: "white",
					},

					title: {
						display: true,
						text: "# Line-Item Transactions",
						color: "white",
					},
					ticks: {
						color: "#ca000000",
						backdropColor: "#ca000000",
						stroke: "#ca000000",
						// textStrokeColor: "red",
						display: true,
						stepSize: 100,
						maxTicksLimit: 10,
					},
				},
				y: {
					title: {
						display: true,
						text: "% of Line-Item Transactions with SPA Applied",
						color: "white",
					},
					ticks: {
						color: "pink",
					},
				},
			},
		},
	};

	const data = {
		labels: labels,
		datasets: [
			{
				label: "",
				data: plottedData,
				pointHoverRadius: pointHoverRadius,
				pointRadius: pointRadius,
				backgroundColor: backgroundColor,
			},
		],
	};

	return (
		<>
			<Bubble
				options={options}
				data={data}
				height={180}
				width={500}
				className="pl-[2vh]"
			/>
			<div className="w-full text-center text-[#818080] text-[1.7vh]">
				# Line-Item Transactions
			</div>
			<div className="px-2">
				<div className=" contentFooter">
					<div className="flex items-center">
						<div className="w-4 h-4 rounded-full border-4 border-[#c79c38]"></div>
						<p className="fontuniv pl-1">GM {"<"} 14%</p>
					</div>

					<div className="flex items-center pl-2">
						<div className="w-4 h-4 rounded-full border-4 border-[#d55454]"></div>
						<p className="fontuniv pl-1">GM 14%-{gmValue * 100}%</p>
					</div>

					<div className="flex items-center pl-2">
						<div className="w-4 h-4 rounded-full border-4 border-[#60b5bf]"></div>
						<p className="fontuniv  pl-1">
							GM {gmValue * 100}%-{gmValue * 100 + 5}%
						</p>
					</div>

					<div className="flex items-center pl-2">
						<div className="w-4 h-4 rounded-full border-4 border-[#86bc25]"></div>
						<p className="fontuniv  pl-1">
							GM {">"} {gmValue * 100 + 5}%
						</p>
					</div>
				</div>
			</div>
		</>
	);
};

export default BubbleChart;
